import BackArrow from 'Assets/Icons/left-arrow-v2.svg';
interface Props {
    placeholder?: string;
    value?: string;
}

function SearchInput(props: Props) {
    return (
        <>
            <div style={{ position: 'relative' }}>
                <input
                    placeholder={props.placeholder || ''}
                    value={props.value}
                    type="text"
                    className="input"
                    readOnly
                />
                <BackArrow
                    style={{
                        position: 'absolute',
                        left: '90%',
                        top: '30%',
                        transform: 'rotate(-90deg)',
                    }}
                ></BackArrow>
            </div>
            <style jsx>{`
                .input {
                    border-radius: 8px;
                    border: 1px solid #e7e7f0;
                    background: #fff;
                    padding: 18px 12px;
                    width: 100%;
                    font-size: 16px;
                    box-sizing: border-box;
                    outline: none;
                }
            `}</style>
        </>
    );
}

export default SearchInput;
